import React from 'react';

// Widget to show the API status as it loads
export const APIStatusWidget = (props: any) => {
  // States from Chatbot config
  const { intIntent, currentStep, intPlan } = props;

  return (
    <div className="api-status ml-[60.5px] mt-[15px] flex w-auto flex-col flex-nowrap items-end justify-center overflow-hidden rounded-lg bg-gamma-purple p-[8px] font-graphik text-base text-white">
      {intIntent ? (
        <div className="intentContainer pointer-events-none flex w-full flex-row flex-nowrap items-center justify-center">
          <div className="intent flex-grow text-center font-bold">{intIntent}</div>
        </div>
      ) : null}
      <div className="showSteps flex w-full flex-col items-start justify-between">
        {currentStep ? (
          <div className="plan-item pointer-events-none mt-2 flex w-full flex-row items-center justify-center text-center">
            {currentStep}
          </div>
        ) : null}
        <div
          className="loading-bar mx-1 my-3 h-1 w-0 rounded-full bg-white"
          style={{
            width:
              intPlan && intPlan.length > 0 && currentStep
                ? ((intPlan.indexOf(currentStep) + 1) / intPlan.length) * 100 + '%'
                : '0%',
            transition: 'width 1s ease-in-out',
          }}
        ></div>
      </div>
    </div>
  );
};
